import axios from "axios"
import { message } from './resetMessage'
import router from '../../router'

axios.defaults.headers['Content-Type'] = 'application/json';

// 请求拦截
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    return config
  },
  err => {
    // 对请求错误做些什么
    return Promise.reject(err)
  }
)

// 响应拦截
axios.interceptors.response.use(
  res => {
    if (res.data.errcode != 0) {
      if (res.data.errcode == 30305) {
        window.localStorage.clear();
        router.replace({
          path: '/Login'
        })
      } else if (res.data.errmsg === "device exists") {
        message.error('设备已存在')
      } else {
        message.error(res.data.errmsg)
      }
    }
    return res
  },
  err => {
    if (err.response.status == 404) {
      message.error('请求失败')
      return
    }
    message.error(err.response.data.errmsg)
    return Promise.reject(err.response);
  }
)
export default axios


// WEBPACK FOOTER //
// ./src/assets/js/axios.js